import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useMutation } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { DateUtils } from '@grandvisionhq/utils';
import { useAppointmentContext } from '../../pages/BookAppointment/context/AppointmentContext.js';
import { BOOK_APPOINTMENT_BY_ID } from '../../queries/book-appointment-by-id.js';
import { getStoredAffiliateId } from '../../utils/affiliate-id-storage.js';
import { fromBookAppointmentMutationToBookedAppointment } from './adapters/fromBookAppointmentMutationToBookedAppointment.js';

const TIMEOUT = 30000;
const useBookAppointmentById = ()=>{
    const { locale  } = useIntl();
    const [, { store , type , timeSlot , tryInStoreProductSkus  }] = useAppointmentContext();
    const [query, queryState] = useMutation(BOOK_APPOINTMENT_BY_ID);
    const bookAppointment = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(token, formData) {
            if (!type || !store || !timeSlot) {
                throw new Error('Invalid application state, undefined type, store or timeslot');
            }
            try {
                yield query(swcHelpers.objectSpread({}, token ? {
                    context: {
                        forwardHeaders: {
                            Authorization: `Bearer ${token}`
                        },
                        timeout: TIMEOUT
                    }
                } : {
                    context: {
                        timeout: TIMEOUT
                    }
                }, {
                    variables: {
                        data: swcHelpers.objectSpread({
                            appointmentTypeId: type.id,
                            globalStoreId: store.globalStoreId,
                            startTime: DateUtils.toLocalDateTime(timeSlot.from),
                            endTime: DateUtils.toLocalDateTime(timeSlot.until),
                            affiliateId: getStoredAffiliateId(),
                            productSkus: tryInStoreProductSkus,
                            preferredLanguage: locale
                        }, formData)
                    }
                }));
            } catch (e) {
                console.error('Error while creating appointment', e);
            }
        });
        return function(token, formData) {
            return _ref.apply(this, arguments);
        };
    }(), [
        type,
        store,
        timeSlot,
        query,
        tryInStoreProductSkus,
        locale
    ]);
    const data = React.useMemo(()=>{
        var ref, ref1;
        return {
            appointment: fromBookAppointmentMutationToBookedAppointment((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.bookAppointment.appointment),
            failures: (ref1 = queryState.data) === null || ref1 === void 0 ? void 0 : ref1.bookAppointment.failures
        };
    }, [
        queryState
    ]);
    return React.useMemo(()=>[
            bookAppointment,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        bookAppointment,
        queryState,
        data
    ]);
};

export { useBookAppointmentById as default, useBookAppointmentById };
//# sourceMappingURL=use-book-appointment-by-id.js.map
